import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import API from "../../api"
const {topHeaderSliderList,topHeaderSliderAdd,topHeaderSliderUpdate,topHeaderSliderDelete,topHeaderSliderEdit}=API

const initialState = { 
    data:[],
    singleTopHeaderSlider:[],
    error: null, 
    loading:false,
    message:'',
    deleteLoad:false,
    editData:[],
}

const topHeaderSliderSlice = createSlice({
    name: "topHeaderSlider",
    initialState,
    reducers: {
      setData(state,action){
          state.data=action.payload;
      },
      setLoading(state, action) {
          state.loading = action.payload;
        },
      setMessage(state,action){
          state.message=action.payload;
      },
      setError(state,action){
          state.error=action.payload;
    },
      setDeleteLoad(state,action){
          state.deleteLoad=action.payload
      },
      setAfterDeleteTopHeaderSlider(state,action){
          state.data=state.data.filter((item)=>item._id !== action.payload)
      },
      setTopHeaderSliderAdd(state,action){
          state.data=[action.payload,...state.data]
      },
      setEditTopHeaderSlider(state,action){
          state.singleTopHeaderSlider=state.data.filter((item)=>item._id === action.payload)
      },
      setBlankSingleData(state,action){
        state.singleTopHeaderSlider=[]
      },
      setEditData(state,action){
          state.editData=action.payload
      }
    },
  });
  
  export const {setEditData, setLoading, setMessage,setError,setData,setDeleteLoad,setTopHeaderSliderAdd,setAfterDeleteTopHeaderSlider,setEditTopHeaderSlider,setBlankSingleData} = topHeaderSliderSlice.actions;
  export default topHeaderSliderSlice.reducer;

  export const getTopHeaderSliderData = () => async (dispatch) => {
         dispatch(setLoading(true));
    try {
      const res= await topHeaderSliderList()
      if (res.data.success) {
          dispatch(setData(res.data.data[0]?.fieldvalue))
          dispatch(setLoading(false));
          dispatch(setMessage(res.data.message))
      } else {
          dispatch(setLoading(false));
          dispatch(setError(res.data.message));
      }
    } catch (e){
      dispatch(setLoading(false));
      dispatch(setError(e.message));
      message.error(e.message);
    }
  };
  export const topHeaderSliderDataAdded=(data) => async (dispatch)=>{
    dispatch(setDeleteLoad(true));
    try{
      const res= await topHeaderSliderAdd(data)
      if(res.data.success) {
         dispatch(setTopHeaderSliderAdd(data))
         dispatch(setDeleteLoad(false))
         dispatch(setMessage(res.data.message))
         message.success(res.data?.message);
      } else {
        dispatch(setDeleteLoad(false));
        dispatch(setError(res.data.message));
        message.error(res.data.message);
    }
    } catch(e){
      dispatch(setDeleteLoad(false));
      dispatch(setError(e.response.data.message));
      message.error(e.response.data.message);
    }
}

export const sigleTopHeaderSliderDataAction=(id) =>(dispatch)=>{
              dispatch(setEditTopHeaderSlider(id))
}

export const topHeaderSliderDataUpdate=(id,data) => async (dispatch)=>{
  dispatch(setDeleteLoad(true));
  try{
    const res= await topHeaderSliderUpdate(id,data)
    if(res.data.success) {
       dispatch(setBlankSingleData())
       dispatch(setEditData())
       dispatch(setDeleteLoad(false))
       dispatch(setMessage(res.data.message))
       message.success(res.data?.message);
    } else {
      dispatch(setDeleteLoad(false));
      dispatch(setError(res.data.message));
      message.error(res.data.message);
  }
  } catch(e){
    dispatch(setDeleteLoad(false));
    dispatch(setError(e.response.data.message));
    message.error(e.response.data.message);
  }
}
export const topHeaderSliderEditAction=(id,field) => async (dispatch)=>{
  try{
    const res= await topHeaderSliderEdit(id,field)
    if(res.data.success) {
       dispatch(setEditData(res.data.data))
    } else {
      message.error(res.data.message);
  }
  } catch(e){
    message.error(e.response.data.message);
  }
}
export const editBlankData=() =>(dispatch)=>{
        dispatch(setEditData())
}
  export const topHeaderSliderDataDelete=(id) => async (dispatch)=>{
          dispatch(setDeleteLoad(true));
          try{
            const res= await topHeaderSliderDelete(id)
            if(res.data.success) {
               dispatch(setAfterDeleteTopHeaderSlider(id))
               dispatch(setDeleteLoad(false))
               dispatch(setMessage(res.data.message))
               message.success(res.data?.message);
            } else {
              dispatch(setDeleteLoad(false));
              dispatch(setError(res.data.message));
              message.error(res.data.message);
          }
          } catch(e){
            dispatch(setDeleteLoad(false));
            dispatch(setError(e.response.data.message));
            message.error(e.response.data.message);
          }
  }